import React, { useRef } from "react";
import { Container } from "reactstrap";
import "./header.css";
import { BiLogIn } from "react-icons/bi"; // Import BiLogIn icon from react-icons/bi
import krishnasLogo from "../../assests/images/logo/krishnas.svg";

const navLinks = [
  {
    display: "Home",
    url: "#",
  },

  {
    display: "Courses",
    url: "#",
  },
  {
    display: "Projects",
    url: "#",
  },
  {
    display: "Blog",
    url: "#",
  },
  {
    display: "Collaboration",
    url: "#",
  },
  {
    display: "Jobs",
    url: "#",
  },
  {
    display: "Contact",
    url: "#",
  },
];

const Header = () => {
  const menuRef = useRef();

  const menuToggle = () => menuRef.current.classList.toggle("active__menu");

  return (
    <header className="header">
      <Container>
        <div className="navigation d-flex align-items-center justify-content-between">
          <div className="logo">
          <h2 className=" d-flex align-items-center gap-1">
              <img
                src={krishnasLogo}
                alt="Krishnas Logo"
                width="340" // Adjust the width as needed
                height="auto" // Auto-adjust the height to maintain proportions
                loading="lazy" // Enable lazy loading
              />
            </h2>
          </div>

          <div className="nav d-flex align-items-center gap-5">
            <div className="nav__menu" ref={menuRef} onClick={menuToggle}>
              <ul className="nav__list">
                {navLinks.map((item, index) => (
                  <li key={index} className="nav__item">
                    <a href={item.url}>{item.display}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="nav__right">
              <p className="mb-0 d-flex align-items-center gap-2">
              <BiLogIn />{" "}
                <a href="/login">Login</a> {/* Add the login page URL */}
              </p>
            </div>
          </div>

          <div className="mobile__menu">
            <span>
              <i class="ri-menu-line" onClick={menuToggle}></i>
            </span>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
